/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEnvelopeOpen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 1.834 10 6.6V22H2V8.434zm0 2.332-8 5.4V20h16V9.566zm5.504 5.965.992 1.737L12 16.151l-6.496-4.283.992-1.737L12 13.848z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEnvelopeOpen as EnvelopeOpen };
